module.exports = __webpack_public_path__ + "img/Fregier.673846ce.png";